import { useState, useEffect } from 'react';
import useFetchFinancialData  from './useFetchFinacialData'; 
import { processFinancialData } from '../utilities/dataProccesingUtils';
import { isEqual } from 'lodash';
import LoadingComponent from '../components/LoadingComponent';

const useLastYearBalanceData = (selectedCompany, startDate, endDate) => {
  const [processedLastYearBalanceData, setProcessedLastYearBalanceData] = useState([]);
  const { data, isLoading, error } = useFetchFinancialData(selectedCompany, startDate, endDate, "Budget");
  useEffect(() => {
    if (data && data.lastYearBalanceData) {
      const newProcessedLastYearBalanceData = processFinancialData(data.lastYearBalanceData);
      if (!isEqual(processedLastYearBalanceData, newProcessedLastYearBalanceData)) {
        setProcessedLastYearBalanceData(newProcessedLastYearBalanceData);
      }
    }
  }, [data, processedLastYearBalanceData]); 
  

  return {
    processedLastYearBalanceData,
    isLoading,
    error,
  };
};

export default useLastYearBalanceData;